import React from 'react';

import { TableCell, TableHeaderCell } from '@hcs/design-system';
import { TableCellProps, TableHeaderCellProps } from '@hcs/types';
import {
  CompFieldConfig,
  CompFields,
  CompFieldsArgs,
  CompFieldsTableCellProps,
} from '@hcs/types';
import { formatMoney } from '@hcs/utils';

const FIELD = CompFields.hcAdjustmentDate;
type FieldConfig = CompFieldConfig<typeof FIELD>;
const label = 'HPI Adjustment';
const labelShort = 'HPI Adjustment';
const compPath: FieldConfig['compPath'] = '/hcAdjustments/hcAdjustmentDate';
const getValue: FieldConfig['getValue'] = (comp) =>
  comp?.hcAdjustments?.hcAdjustmentDate;
const formatValue: FieldConfig['formatValue'] = (comp) =>
  formatMoney(getValue(comp));
const formatInline: FieldConfig['formatInline'] = (comp) =>
  formatMoney(getValue(comp));
// Info for glossary or tooltip
const info: FieldConfig['info'] =
  'HouseCanary’s home price index adjustment is a time-based adjustment to match the report effective date';
// Component for displaying a field from a schema
// eslint-disable-next-line react-refresh/only-export-components
const Display: FieldConfig['Display'] = ({ comp }: CompFieldsArgs) => {
  return <>{formatValue(comp)}</>;
};

// eslint-disable-next-line react-refresh/only-export-components
const HeaderCell = (props: TableHeaderCellProps) => {
  return <TableHeaderCell {...props}>{labelShort}</TableHeaderCell>;
};
// Using default props allows for child.props checks
// in the Table components to work properly
const defaultHeaderProps: Partial<TableHeaderCellProps> = {
  align: 'right',
  // Needed so child component type-checking passes
  isTableHeaderCell: true,
};
HeaderCell.defaultProps = defaultHeaderProps;

// eslint-disable-next-line react-refresh/only-export-components
const ContentCell = ({ comp, ...tableCellProps }: CompFieldsTableCellProps) => {
  return (
    <TableCell {...tableCellProps}>
      <Display comp={comp} />
    </TableCell>
  );
};
// Using default props allows for child.props checks
// in the Table components to work properly
const defaultContentProps: Partial<TableCellProps> = {
  align: 'right',
  // Needed so child component type-checking passes
  isTableCell: true,
};
ContentCell.defaultProps = defaultContentProps;

export const HC_ADJUSTMENT_DATE_CONFIG: FieldConfig = {
  field: FIELD,
  label,
  labelShort,
  compPath,
  info,
  getValue,
  formatValue,
  formatInline,
  HeaderCell,
  ContentCell,
  Display,
};
